import styled from "styled-components";
import CenterArea from "./CenterArea";

const CenterPage = styled(CenterArea)`
    height: 100%;
`;

export default CenterPage;